module.exports = __webpack_public_path__ + "static/media/fir_ext_foa.7eeece40.png";